import { IonApp, IonLoading, useIonToast } from "@ionic/react"; // importar IonApp y hook de toast para notificaciones
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUTCUtils from "src/utils/MomentUTCUtils";
import moment from "moment";
import "moment/locale/es-mx";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "src/theme/variables.css";
import "src/theme/main.css";

import { capitalize, Sesion } from "src/utils";
import Login from "src/pages/Login";
import Home from "src/pages/Home";
import ActualizarDatos from "src/pages/ActualizarDatos";
import Marcaciones from "src/pages/Marcaciones";
import RecibosSalariales from "src/pages/RecibosSalariales";
import ReembolsosPasajes from "src/pages/ReembolsosPasajes";
import ReembolsoPasajeDetalle from "src/pages/ReembolsoPasajeDetalle";
import ReembolsoPasajeReclamo from "src/pages/ReembolsoPasajeReclamo";
import Menu from "src/components/Menu";
import api from "src/services/api";
import { SESSION_EXPIRED_EVENT } from "src/services/api"; // Importamos el nombre del evento global de expiración de sesión
import Storage from "src/services/storage";
import LoginAPI from "src/services/login";
import Nosotros from "./pages/Nosotros";
import Documentaciones from "./pages/Documentaciones";
import Asignacion from "./pages/Asignacion";
import { GestionMarcacionSalida } from './components/GestionMarcacion/GestionMarcacionSalida'
import { GestionMarcacionEntrada } from "./components/GestionMarcacion/GestionMarcacionEntrada";
import HistorialConFiltro from "./pages/HistorialConFiltro";
import ReclamosProceso from "./pages/ReclamosProceso";
import ReclamosConFiltro from "./pages/ReclamosConFiltro";
import AsignacionDetalle from "./pages/AsignacionDetalle";
import AsignacionDTEdicion from './pages/AsignacionDTEdicion';
import Denuncias from "./components/Denuncias/Denuncias";
import { GestionMarcacionSupera } from "./components/GestionMarcacion/GestionMarcacionSupera";
import CierreDiarioOperarios from "./pages/CierreDiarioOperarios";
import CierreDiario from "./pages/CierreDiario";
import Fiscalizacion from "./pages/Fiscalizacion";
import MisCasosFiscal from "./pages/MisCasosFiscal";
import FiscalizarPersonal from "./pages/FiscalizarPersonal";
import FiscalizarDeposito from "./pages/FiscalizarDeposito";
import FiscalizarMaquina from "./pages/FiscalizarMaquina";
import FiscalizarLimpieza from "./pages/FiscalizarLimpieza";
import FiscalizarOpinion from "./pages/FiscalizarOpinion";
import FiscalizarStock from "./pages/FiscalizarStock";
import FiscalizarInicio from "./pages/FiscalizarInicio";
import Marcacion from "./pages/Marcacion";
import HorasProcesadas from "./pages/HorasProcesadas";
import GestionTipoHora from "./components/GestionTipoHora";
import { GestionTipoHoraView } from "./pages/GestionTipoHoraView";
import Comunicados from "./pages/Comunicados";
import ResumenFiscalizacion from "./components/Fiscalizacion/ResumenFiscalizacion";
import PedidoDeProductos from './pages/PedidoDeProductos'
import PedidoDeProductosDetalle from "./pages/PedidoDeProductosDetalle";
import LimpiezasProfundas from "./pages/LimpiezasProfundas";
import LimpiezasProfundasDetalle from "./pages/LimpiezasProfundasDetalle";
import Acompanamiento from "./pages/Acompanamiento";
import AcompanamientoForm from "./pages/AcompanamientoForm";
import EntregaFolleto from "./pages/EntregaFolleto";
import ReemplazosV2 from "./modules/reemplazosV2/pages/ReemplazosV2";
import AsignacionesV2 from "./modules/asignacionesV2/pages/AsignacionesV2";
import AsignacionesV2Detalle from "./modules/asignacionesV2/pages/AsignacionesV2Detalle";
import MisPedidos from "./pages/MisPedidos";
import MisAsignaciones from "./pages/MisAsignaciones";
import MisReemplazos from "./pages/MisReemplazos";
import NotificacionReemplazos from "./pages/NotificacionReemplazos";
import ReporteReemplazosContact from "./pages/ReporteReemplazosContact";
import EvaluacionDesempeno from "./pages/EvaluacionDesempeno"; // formulario "Nuevo"
import EvaluacionDesempenoDetalle from "./pages/EvaluacionDesempenoDetalle"; // importar detalle por ID
import EvaluacionDesempenoHome from "./pages/EvaluacionDesempenoHome"; // listado inicial
import EvaluacionDesempenoReporte from "./pages/EvaluacionDesempenoReporte"; // reporte jerárquico (solo usuario autorizado)
import EvaluacionVisitas from "./pages/EvaluacionVisitas";
import EvaluacionReconocimiento from "./pages/EvaluacionReconocimiento";
import RelevamientoVisitas from "./pages/RelevamientoVisitas";
import VisitasUnidadesEspecializadas from "./pages/VisitasUnidadesEspecializadas";
import RelevamientoOperativo from "./pages/RelevamientoOperativo";
import RelevamientoOperativoListado from "./pages/RelevamientoOperativoListado";
import OrdenTrabajo from "./pages/OrdenTrabajo";
import Rutinas from "./pages/Rutinas";
import MiRutina from "./pages/MiRutina";
import EvaluacionCapacitacion from "./pages/EvaluacionCapacitacion";
import ServiciosEspecializados from "./pages/ServiciosEspecializados";
import ServiciosEspecializadosDetalle from "./pages/ServiciosEspecializadosDetalle";
import AsignacionesCapacitador from "./pages/AsignacionesCapacitador";
import SugerenciaPs from "./pages/SugerenciaPs";
import { puedeVerSugerenciaPs } from "./config/sugerenciaPs";
import RegistroCapacitacion from "./pages/RegistroCapacitacion";
import SolicitudesCapacitacion from "./pages/SolicitudesCapacitacion";
import SolicitudCapacitacionCierre from "./pages/SolicitudCapacitacionCierre";
import AccionesCorrectivas from "./pages/AccionesCorrectivas";
import AccionCorrectivaDetalle from "./pages/AccionCorrectivaDetalle";
import SolicitudesSst from "./pages/SolicitudesSst";
import SolicitudSstDetalle from "./pages/SolicitudSstDetalle";
import SolicitudesGafcore from "./pages/SolicitudesGafcore";
import SolicitudGafcoreDetalle from "./pages/SolicitudGafcoreDetalle";
import SolicitudesGafcoreMenu from "./pages/SolicitudesGafcoreMenu";
import SolicitudesMantenimiento from "./pages/SolicitudesMantenimiento";
import SolicitudMantenimientoDetalle from "./pages/SolicitudMantenimientoDetalle";
import HistorialCapacitacion from "./pages/HistorialCapacitacion";
import CapacitacionMantenimiento, { GuardMantenimientoCapacitacion } from "./pages/CapacitacionMantenimiento";
import CapacitacionTemaEvaluacion from "./pages/CapacitacionTemaEvaluacion";
import RegistroCapacitacionAPI, { RolCapacitacion, ROL_SESSION_KEY as CAPACITACION_ROL_KEY } from "./services/registroCapacitacion";
import Recursos from "./pages/Recursos";
import RecursosAdmin from "./pages/RecursosAdmin";
import EvaluacionPendienteModal from "./components/EvaluacionPendienteModal";
import EventoEvaluacionModal from "./components/EventoEvaluacionModal";
import EventoRespuestaModal from "./components/EventoRespuestaModal";
import MicroEncuestaModal from "./components/MicroEncuestaModal";
import ComunicadoModal from "./components/ComunicadoModal";
import ActualizarDatosModal from "./components/ActualizarDatosModal";
import { useEstadoPerfil, PERFIL_REFETCH_EVENT } from "./hooks/useEstadoPerfil";
import EventosAdmin from "./pages/EventosAdmin";
import EventoAsistencia from "./pages/EventoAsistencia";
import CapacitacionesAdm from "./pages/CapacitacionesAdm";
import CapacitacionAdmForm from "./pages/CapacitacionAdmForm";
import CapacitacionAdmDetalle from "./pages/CapacitacionAdmDetalle";
import CapacitacionAdmMis from "./pages/CapacitacionAdmMis";
import CapacitacionAdmPendientesModal from "./components/CapacitacionAdmPendientesModal";
import { CAPADM_ACCESO_KEY } from "./services/capacitacionAdm";
import AgendaUsuario from "./pages/AgendaUsuario";
import AgendaReservar from "./pages/AgendaReservar";
import AgendaGestion from "./pages/AgendaGestion";
import AgendaTemaForm from "./pages/AgendaTemaForm";
import AgendaTemaDetalle from "./pages/AgendaTemaDetalle";
import { AGENDA_ACCESO_KEY } from "./services/agenda";
import { CAPACITACION_PERMISO_SESSION_KEY, permisoCapacitacionEnSesion } from "./services/solicitudCapacitacion";
import PlanificacionVisitas from "./pages/PlanificacionVisitas";
import AsignacionRecursos from "./pages/AsignacionRecursos";

import GestionErrores from "./modules/gestionErrores/pages/GestionErrores";
import GestionErroresDetalle from "./modules/gestionErrores/pages/GestionErroresDetalle";
import ClimaOrganizacional from "./pages/ClimaOrganizacional";
import MiPerfil from "./pages/MiPerfil";
import Settings from "src/pages/Settings";
import ModulePermissions from "src/pages/ModulePermissions";
import NotificacionTardanza from "src/pages/NotificacionTardanza";
import GestionAusencia from "src/pages/GestionAusencia";
import AtcMisCitas from "src/pages/AtcMisCitas";
import AtcDetalleCita from "src/pages/AtcDetalleCita";
import AtcNuevaCita from "src/pages/AtcNuevaCita";
import AtcFeedback from "src/pages/AtcFeedback";
import Solicitudes from "src/pages/Solicitudes";
import SolicitudesRRHHMis from "src/pages/SolicitudesRRHHMis";
import SolicitudRRHHNueva from "src/pages/SolicitudRRHHNueva";
import SolicitudRRHHDetalle from "src/pages/SolicitudRRHHDetalle";
import Mensajes from "src/pages/Mensajes";
import ChatConversacion from "src/pages/ChatConversacion";
import ChatFloatingButton from "src/components/ChatFloatingButton";
import GerenteFiscalSelector from "src/components/GerenteFiscalSelector";
import MiQREntrega from "src/pages/MiQREntrega";
import RegistrarEntrega from "src/pages/RegistrarEntrega";
import AdminEntregasMasivas from "src/pages/AdminEntregasMasivas";
import { obtenerMiRol } from "src/services/entregasMasivas";
import MiStock from "src/pages/MiStock";
// Importar utilidades de verificación del backend
import { logBackendInfo, checkBackendHealth, diagnoseBackendIssues } from "./utils/backendHealth";
import { EVALUACION_SOLO_TIC, ENTORNO_ES_DESARROLLO } from "src/config/entorno"; // importar flag de evaluación y flag de entorno (TEST)
import { getBackendURL, environment } from "src/config/environment"; // importar helpers para URL efectiva del backend y constantes de entorno
import { SW_UPDATE_STATUS_EVENT, SwUpdateStatus } from "src/utils/swUpdateEvents";
import { initDeviceId } from "src/utils/deviceId";
import UpdateAvailableToast from "src/components/UpdateAvailableToast";
import DispositivoSeguroPrompt from "src/components/DispositivoSeguroPrompt";
import { canAccessPath, getModuleByPath, loadModulePermissions } from "src/config/modulePermissions";
import { esGerenteDeOperaciones, guardarFiscalActuando } from "src/config/gerenteOperaciones";
import { DEPARTAMENTOS_SOLICITUDES, departamentoVisible } from "src/config/departamentosSolicitudes";
import { sincronizarPermisosModulos } from "src/services/modulePermissions";
import { useRef as useReactRef } from "react";
import { useGestionAusenciaPendiente } from "src/hooks/useGestionAusenciaPendiente";
import { GestionAusenciaActiva } from "src/services/gestionAusencia";

// =====================================================================
// Guarda de evaluaciones pendientes:
// Si el usuario tiene evaluaciones de capacitación sin completar y entra
// a salarios / historial / reclamos, se fuerza la apertura del modal en
// modo "no se puede saltar".
//
// Definido FUERA del componente App para evitar que cada re-render lo
// desmonte y vuelva a montar, lo cual dispararía el useEffect múltiples
// veces (causando muchas llamadas innecesarias al endpoint).
// =====================================================================
const RUTAS_BLOQUEADAS_EVAL = ["/salarios", "/historial-de-trabajo", "/reclamos"];

interface EvaluacionGuardProps {
  isAuth: boolean;
  evalPendientes: number;
  setEvalBloqueado: (b: boolean) => void;
  setEvalReapertura: React.Dispatch<React.SetStateAction<number>>;
  present: ReturnType<typeof useIonToast>[0];
}

const EvaluacionGuard: React.FC<EvaluacionGuardProps> = ({
  isAuth,
  evalPendientes,
  setEvalBloqueado,
  setEvalReapertura,
  present,
}) => {
  const loc = useLocation();
  const ultimaRutaBloqueada = useReactRef<string | null>(null);
  const presentRef = useReactRef(present);
  useEffect(() => { presentRef.current = present; });

  useEffect(() => {
    if (!isAuth) {
      setEvalBloqueado(false);
      ultimaRutaBloqueada.current = null;
      return;
    }
    const enRutaBloqueada = RUTAS_BLOQUEADAS_EVAL.some(
      (r) => loc.pathname === r || loc.pathname.startsWith(`${r}/`)
    );

    if (enRutaBloqueada && evalPendientes > 0) {
      setEvalBloqueado(true);
      // Solo disparamos reapertura/toast cuando es una nueva entrada a la
      // ruta bloqueada (no en cada re-render con la misma ruta).
      if (ultimaRutaBloqueada.current !== loc.pathname) {
        ultimaRutaBloqueada.current = loc.pathname;
        setEvalReapertura((c) => c + 1);
        presentRef.current({
          message:
            "Debés completar tus evaluaciones de capacitación pendientes para acceder a esta sección.",
          duration: 4000,
          color: "warning",
        });
      }
    } else {
      setEvalBloqueado(false);
      if (!enRutaBloqueada) ultimaRutaBloqueada.current = null;
    }
  }, [loc.pathname, isAuth, evalPendientes, setEvalBloqueado, setEvalReapertura]);

  return null;
};

// =====================================================================
// Modal global de actualización de perfil:
// Cuando el operario aprieta "Saltar" estando en una ruta bloqueada
// (salarios / historial / reclamos), lo devolvemos a /home para que no
// pueda acceder a esas pantallas con datos desactualizados. Si está en
// cualquier otra ruta (ej. /home), saltar solo cierra el modal.
// =====================================================================
interface PerfilModalSlotProps {
  isOpen: boolean;
  forzado: boolean;
  onSaltar: () => void;
  onGuardado: () => void;
}

const PerfilModalSlot: React.FC<PerfilModalSlotProps> = ({ isOpen, forzado, onSaltar, onGuardado }) => {
  const history = useHistory();
  const handleClose = () => {
    onSaltar();
    if (forzado) {
      history.replace("/home");
    }
  };
  return (
    <ActualizarDatosModal
      isOpen={isOpen}
      forzado={forzado}
      onClose={handleClose}
      onSaved={onGuardado}
    />
  );
};

// =====================================================================
// Guarda de actualización de perfil pendiente (campaña vigente):
// Si el operario tiene datos desactualizados (versión del perfil < versión
// vigente de AE_PerfilVersionConfig) y entra a salarios / historial / reclamos,
// se fuerza la apertura del modal de actualización en modo bloqueado.
// =====================================================================
const RUTAS_BLOQUEADAS_PERFIL = ["/salarios", "/historial-de-trabajo", "/reclamos"];

interface PerfilGuardProps {
  isAuth: boolean;
  needsUpdate: boolean;
  setPerfilBloqueado: (b: boolean) => void;
  setPerfilReapertura: React.Dispatch<React.SetStateAction<number>>;
  present: ReturnType<typeof useIonToast>[0];
}

const PerfilGuard: React.FC<PerfilGuardProps> = ({
  isAuth,
  needsUpdate,
  setPerfilBloqueado,
  setPerfilReapertura,
  present,
}) => {
  const loc = useLocation();
  const ultimaRutaBloqueada = useReactRef<string | null>(null);
  const presentRef = useReactRef(present);
  useEffect(() => { presentRef.current = present; });

  useEffect(() => {
    if (!isAuth) {
      setPerfilBloqueado(false);
      ultimaRutaBloqueada.current = null;
      return;
    }
    const enRutaBloqueada = RUTAS_BLOQUEADAS_PERFIL.some(
      (r) => loc.pathname === r || loc.pathname.startsWith(`${r}/`)
    );

    if (enRutaBloqueada && needsUpdate) {
      setPerfilBloqueado(true);
      if (ultimaRutaBloqueada.current !== loc.pathname) {
        ultimaRutaBloqueada.current = loc.pathname;
        setPerfilReapertura((c) => c + 1);
        presentRef.current({
          message:
            "Debés actualizar tus datos personales para acceder a esta sección.",
          duration: 4000,
          color: "warning",
        });
      }
    } else {
      setPerfilBloqueado(false);
      if (!enRutaBloqueada) ultimaRutaBloqueada.current = null;
    }
  }, [loc.pathname, isAuth, needsUpdate, setPerfilBloqueado, setPerfilReapertura]);

  return null;
};

// =====================================================================
// Guarda de evaluación de EVENTO pendiente:
// Mismo comportamiento que EvaluacionGuard pero para la evaluación
// post-evento (módulo Eventos). Bloquea las mismas rutas protegidas.
// =====================================================================
interface EventoEvalGuardProps {
  isAuth: boolean;
  eventoEvalPendiente: number;
  setEventoEvalBloqueado: (b: boolean) => void;
  setEventoEvalReapertura: React.Dispatch<React.SetStateAction<number>>;
  present: ReturnType<typeof useIonToast>[0];
}

const EventoEvaluacionGuard: React.FC<EventoEvalGuardProps> = ({
  isAuth,
  eventoEvalPendiente,
  setEventoEvalBloqueado,
  setEventoEvalReapertura,
  present,
}) => {
  const loc = useLocation();
  const ultimaRutaBloqueada = useReactRef<string | null>(null);
  const presentRef = useReactRef(present);
  useEffect(() => { presentRef.current = present; });

  useEffect(() => {
    if (!isAuth) {
      setEventoEvalBloqueado(false);
      ultimaRutaBloqueada.current = null;
      return;
    }
    const enRutaBloqueada = RUTAS_BLOQUEADAS_EVAL.some(
      (r) => loc.pathname === r || loc.pathname.startsWith(`${r}/`)
    );

    if (enRutaBloqueada && eventoEvalPendiente > 0) {
      setEventoEvalBloqueado(true);
      if (ultimaRutaBloqueada.current !== loc.pathname) {
        ultimaRutaBloqueada.current = loc.pathname;
        setEventoEvalReapertura((c) => c + 1);
        presentRef.current({
          message:
            "Debés completar la evaluación del evento para acceder a esta sección.",
          duration: 4000,
          color: "warning",
        });
      }
    } else {
      setEventoEvalBloqueado(false);
      if (!enRutaBloqueada) ultimaRutaBloqueada.current = null;
    }
  }, [loc.pathname, isAuth, eventoEvalPendiente, setEventoEvalBloqueado, setEventoEvalReapertura]);

  return null;
};

// =====================================================================
// Guarda de respuesta OBLIGATORIA de asistencia a evento:
// Misma regla que la actualización de datos: si el usuario tiene una
// invitación pendiente de responder en un evento con respuesta_obligatoria
// y entra a salarios / historial / reclamos, se fuerza el modal de
// respuesta hasta que conteste si asistirá o no.
// =====================================================================
interface EventoRespuestaGuardProps {
  isAuth: boolean;
  eventoRespPendiente: number;
  setEventoRespBloqueado: (b: boolean) => void;
  setEventoRespReapertura: React.Dispatch<React.SetStateAction<number>>;
  present: ReturnType<typeof useIonToast>[0];
}

const EventoRespuestaGuard: React.FC<EventoRespuestaGuardProps> = ({
  isAuth,
  eventoRespPendiente,
  setEventoRespBloqueado,
  setEventoRespReapertura,
  present,
}) => {
  const loc = useLocation();
  const ultimaRutaBloqueada = useReactRef<string | null>(null);
  const presentRef = useReactRef(present);
  useEffect(() => { presentRef.current = present; });

  useEffect(() => {
    if (!isAuth) {
      setEventoRespBloqueado(false);
      ultimaRutaBloqueada.current = null;
      return;
    }
    const enRutaBloqueada = RUTAS_BLOQUEADAS_EVAL.some(
      (r) => loc.pathname === r || loc.pathname.startsWith(`${r}/`)
    );

    if (enRutaBloqueada && eventoRespPendiente > 0) {
      setEventoRespBloqueado(true);
      if (ultimaRutaBloqueada.current !== loc.pathname) {
        ultimaRutaBloqueada.current = loc.pathname;
        setEventoRespReapertura((c) => c + 1);
        presentRef.current({
          message:
            "Debés responder la invitación al evento para acceder a esta sección.",
          duration: 4000,
          color: "warning",
        });
      }
    } else {
      setEventoRespBloqueado(false);
      if (!enRutaBloqueada) {
        ultimaRutaBloqueada.current = null;
      } else if (ultimaRutaBloqueada.current !== loc.pathname) {
        // Entró a una ruta protegida sin pendiente conocido: re-verificamos
        // igual. El check inicial corre solo al loguearse, así que un evento
        // publicado DESPUÉS (con la sesión ya abierta) quedaría invisible para
        // este guard. El bump hace que el modal consulte de nuevo; si hay
        // pendiente, se abre, marca pendiente=1 y este guard bloquea en el
        // siguiente render (no marcamos ultimaRutaBloqueada acá para que ese
        // segundo pase dispare el toast).
        setEventoRespReapertura((c) => c + 1);
      }
    }
  }, [loc.pathname, isAuth, eventoRespPendiente, setEventoRespBloqueado, setEventoRespReapertura]);

  return null;
};

// =====================================================================
// Guarda de gestion de ausencia pendiente:
// Si el operario tiene una GestionAusencia en estado PENDIENTE/NOTIFICADO
// (el endpoint /gestion-ausencia/activa filtra por esos estados), forzamos
// la pantalla /gestion-ausencia/<id> y bloqueamos cualquier otra navegacion
// hasta que responda. Sale del bloqueo cuando el endpoint devuelve null
// (gestion respondida o cerrada).
//
// Definido FUERA del componente App para evitar que cada re-render lo
// desmonte y vuelva a montar.
// =====================================================================
interface GestionAusenciaGuardProps {
  isAuth: boolean;
  gestionPendiente: GestionAusenciaActiva | null;
  present: ReturnType<typeof useIonToast>[0];
}

const GestionAusenciaGuard: React.FC<GestionAusenciaGuardProps> = ({
  isAuth,
  gestionPendiente,
  present,
}) => {
  const loc = useLocation();
  const history = useHistory();
  const ultimaRutaBloqueada = useReactRef<string | null>(null);
  const presentRef = useReactRef(present);
  useEffect(() => { presentRef.current = present; });

  useEffect(() => {
    if (!isAuth || !gestionPendiente) {
      ultimaRutaBloqueada.current = null;
      return;
    }

    const rutaDestino = `/gestion-ausencia/${gestionPendiente.gestion_id}`;
    const yaEnDestino = loc.pathname === rutaDestino;
    // /login se respeta para que el logout y la pantalla de login no queden secuestrados
    const esLogin = loc.pathname === "/login";

    if (yaEnDestino || esLogin) {
      ultimaRutaBloqueada.current = null;
      return;
    }

    history.replace(rutaDestino);
    if (ultimaRutaBloqueada.current !== loc.pathname) {
      ultimaRutaBloqueada.current = loc.pathname;
      presentRef.current({
        message:
          "Tenes una notificacion de ausencia pendiente. Respondela para continuar usando la app.",
        duration: 4000,
        color: "warning",
      });
    }
  }, [isAuth, gestionPendiente, loc.pathname, history]);

  return null;
};

// Componente de tirita de ambiente visible solo en modo desarrollo del front
const EnvironmentRibbon: React.FC = () => { // componente funcional para la franja superior
  if (process.env.NODE_ENV !== 'development') return null; // mostrar solo cuando el front corre en modo desarrollo
  const effectiveURL = getBackendURL(); // obtener la URL efectiva del backend en este momento
  const isProdBackend = effectiveURL === environment.api.baseURL; // determinar si el backend apunta a producción
  const label = isProdBackend ? 'PRODU' : 'TEST'; // texto a repetir según el backend efectivo
  const backgroundColor = isProdBackend ? '#c62828' : '#2e7d32'; // color: rojo para producción, verde para test
  const RIBBON_HEIGHT = 24; // alto fijo de la tirita en píxeles

  const [repeated, setRepeated] = useState<string>(''); // texto repetido según el ancho

  useEffect(() => { // efecto para recalcular texto al montar y al redimensionar
    const compute = () => { // función para calcular repeticiones
      const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0); // ancho efectivo de viewport
      const approxCharPx = 10; // ancho aproximado por carácter con font-size 12px
      const base = Math.ceil(width / (label.length * approxCharPx)) + 6; // repeticiones necesarias más margen
      const count = Math.max(16, base); // asegurar un mínimo para evitar cortes
      setRepeated(new Array(count).fill(label).join(' ')); // setear cadena repetida
    };
    compute(); // calcular al montar
    window.addEventListener('resize', compute); // escuchar cambios de tamaño
    return () => window.removeEventListener('resize', compute); // limpiar listener al desmontar
  }, [label]); // recalcular si cambia el label

  return ( // devolver el banner fijo en la parte superior
    <div
      style={{
        position: 'sticky', // mantener visible pero participar del flujo de layout
        top: 0, // se pega al top al hacer scroll
        width: '100%', // ocupar todo el ancho disponible
        height: RIBBON_HEIGHT, // alto de la tirita
        lineHeight: `${RIBBON_HEIGHT}px`, // alinear verticalmente el texto
        backgroundColor, // color de fondo según backend
        color: '#ffffff', // texto blanco
        fontWeight: 700, // enfatizar texto
        fontSize: 12, // tamaño de fuente pequeño
        letterSpacing: 2, // espaciado de letras para legibilidad
        zIndex: 9999, // mantener por encima del contenido
        textTransform: 'uppercase', // texto en mayúsculas
        userSelect: 'none', // evitar selección accidental
        pointerEvents: 'none', // no interceptar clics de la UI (por seguridad)
        whiteSpace: 'nowrap', // evitar cortes en múltiples líneas
        overflow: 'hidden', // ocultar desbordes
        textAlign: 'center', // centrar el texto
      }}
      aria-hidden="true" // accesibilidad: elemento puramente informativo visual
    >
      {repeated} {/* renderizar el texto repetido */}
    </div>
  );
};

const App: React.FC = () => {
  const [user, setUser] = useState<string>("");
  const [cargo, setCargo] = useState<string | undefined>(undefined);
  const [cedulaUsuario, setCedulaUsuario] = useState<string>("");
  const [isAuth, setIsAuth] = useState(false);
  const [present] = useIonToast();
  const [swUpdating, setSwUpdating] = useState<boolean>(false);
  // Cantidad de evaluaciones de capacitación pendientes del usuario logueado.
  // Si > 0 y está en una ruta protegida, se fuerza la apertura del modal.
  const [evalPendientes, setEvalPendientes] = useState<number>(0);
  // Cuando es true, el modal de evaluación oculta el botón "Saltar".
  const [evalBloqueado, setEvalBloqueado] = useState<boolean>(false);
  // Contador para forzar la reapertura del modal de evaluación.
  const [evalReapertura, setEvalReapertura] = useState<number>(0);
  // Evaluación de EVENTO pendiente (módulo Eventos): mismo mecanismo de bloqueo.
  const [eventoEvalPendiente, setEventoEvalPendiente] = useState<number>(0);
  const [eventoEvalBloqueado, setEventoEvalBloqueado] = useState<boolean>(false);
  const [eventoEvalReapertura, setEventoEvalReapertura] = useState<number>(0);
  // Respuesta OBLIGATORIA de asistencia a evento pendiente: mismo mecanismo.
  const [eventoRespPendiente, setEventoRespPendiente] = useState<number>(0);
  const [eventoRespBloqueado, setEventoRespBloqueado] = useState<boolean>(false);
  const [eventoRespReapertura, setEventoRespReapertura] = useState<number>(0);
  // Gestion de ausencia pendiente del operario (estado PENDIENTE/NOTIFICADO).
  // Si != null, GestionAusenciaGuard fuerza /gestion-ausencia/<id> hasta responder.
  const { gestionPendiente } = useGestionAusenciaPendiente({ isAuth });
  // Estado de actualización de datos personales (campaña vigente).
  // Si needsUpdate=true y entra a rutas bloqueadas, se fuerza el modal.
  const { needsUpdate: perfilNeedsUpdate } = useEstadoPerfil({ isAuth });
  const [perfilBloqueado, setPerfilBloqueado] = useState<boolean>(false);
  const [perfilReapertura, setPerfilReapertura] = useState<number>(0);
  const [perfilModalOpen, setPerfilModalOpen] = useState<boolean>(false);

  // Rol admin de Entregas Masivas resuelto contra la tabla AE_EntregasMasivas_Admins
  // (vía backend /entregas-masivas/mi-rol). Tri-estado: null = cargando/aún sin
  // resolver, true/false = resultado. Reemplaza a la antigua lista hardcodeada de
  // cédulas que protegía la ruta /entregas-masivas/admin.
  const [esAdminEntregasMasivas, setEsAdminEntregasMasivas] = useState<boolean | null>(null);

  // Capacitaciones (Técnica / Seguridad): qué tipos registra y administra el
  // usuario (tabla AE_C_Admin + cargo de capacitador técnico). null = cargando.
  const [rolCapacitacion, setRolCapacitacion] = useState<RolCapacitacion | null>(null);

  // Cuando el guard detecta una ruta bloqueada con needsUpdate=true,
  // incrementa perfilReapertura: abrimos el modal forzado.
  useEffect(() => {
    if (perfilReapertura > 0 && perfilBloqueado) {
      setPerfilModalOpen(true);
    }
  }, [perfilReapertura, perfilBloqueado]);

  // Si el usuario deja de tener needsUpdate (por ejemplo, guardó), cerramos el modal.
  useEffect(() => {
    if (!perfilNeedsUpdate) {
      setPerfilModalOpen(false);
    }
  }, [perfilNeedsUpdate]);

  useEffect(() => {
    // Verificar conectividad del backend al iniciar la aplicación
    checkBackendConnectivity();
    cargarSesion();
    // Reconciliar el Installation ID (device binding) entre la capa nativa durable
    // y localStorage. Best-effort: no bloquea el arranque.
    initDeviceId().catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let activo = true;

    const syncPermisos = async () => {
      if (!isAuth) return;
      await sincronizarPermisosModulos();
      if (!activo) return;
    };

    syncPermisos();

    return () => {
      activo = false;
    };
  }, [isAuth]);

  // Resolver el rol admin de Entregas Masivas desde el backend (tabla
  // AE_EntregasMasivas_Admins). Mismo criterio que usa el Menú para mostrar la
  // opción, así el guard de la ruta y el menú quedan consistentes.
  useEffect(() => {
    let activo = true;
    if (!isAuth) {
      setEsAdminEntregasMasivas(null);
      return;
    }
    (async () => {
      try {
        const rol = await obtenerMiRol();
        if (activo) setEsAdminEntregasMasivas(Boolean(rol?.es_admin));
      } catch {
        if (activo) setEsAdminEntregasMasivas(false);
      }
    })();
    return () => {
      activo = false;
    };
  }, [isAuth]);

  useEffect(() => {
    let activo = true;
    if (!isAuth) {
      setRolCapacitacion(null);
      return;
    }
    // Forzado: al iniciar sesión se pide de nuevo (el Menú usa la cache de la sesión).
    RegistroCapacitacionAPI.miRol(true).then((rol) => {
      if (activo) setRolCapacitacion(rol);
    });
    return () => {
      activo = false;
    };
  }, [isAuth]);

  // Indicador de actualización del Service Worker (solo cuando hay update al abrir).
  useEffect(() => {
    let timeout: any;

    const handler = (ev: Event) => {
      const custom = ev as CustomEvent<{ status?: SwUpdateStatus }>;
      const status = custom?.detail?.status;
      const isUpdating = status === 'updating';
      setSwUpdating(isUpdating);

      // Safety: si por algún motivo el update no completa (red/servidor),
      // no dejamos al usuario bloqueado indefinidamente.
      if (timeout) clearTimeout(timeout);
      if (isUpdating) {
        timeout = setTimeout(() => setSwUpdating(false), 30000);
      }
    };

    window.addEventListener(SW_UPDATE_STATUS_EVENT, handler);
    return () => {
      if (timeout) clearTimeout(timeout);
      window.removeEventListener(SW_UPDATE_STATUS_EVENT, handler);
    };
  }, []);

  // Branding dinámico para entorno de TEST (desarrollo)
  useEffect(() => { // useEffect para ejecutar lógica tras montar el componente
    if (!ENTORNO_ES_DESARROLLO) return; // si no estamos en TEST (desarrollo), no aplicar cambios

    document.title = "TEST"; // cambiar el título de la pestaña a "TEST"

    const appNameMeta = document.querySelector('meta[name="application-name"]') as HTMLMetaElement | null; // obtener meta application-name
    if (appNameMeta) appNameMeta.content = "TEST"; // actualizar el nombre de la aplicación para PWA

    const appleNameMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]') as HTMLMetaElement | null; // obtener meta para iOS
    if (appleNameMeta) appleNameMeta.content = "TEST"; // actualizar título para "Añadir a inicio" en iOS

    const manifestLink = document.querySelector('link[rel="manifest"]') as HTMLLinkElement | null; // obtener link del manifest
    if (manifestLink) manifestLink.href = "/manifest-test.json"; // apuntar al manifest de TEST

    const faviconLink = ( // localizar favicon estándar
      document.querySelector('link[rel="shortcut icon"]') as HTMLLinkElement | null
    ) || ( // fallback: algunos proyectos usan rel="icon"
      document.querySelector('link[rel="icon"]') as HTMLLinkElement | null
    );
    if (faviconLink) { // si existe el link de favicon
      faviconLink.type = "image/svg+xml"; // indicar tipo SVG
      faviconLink.href = "/assets/icon/favicon-test.svg"; // apuntar al favicon de TEST
    }
  }, []); // dependencias vacías: ejecutar una sola vez

  // Componente de escucha de ruta (reservado para extensiones futuras)
  const RouteListener: React.FC = () => {
    const loc = useLocation();
    const history = useHistory();

    useEffect(() => {
      if (!isAuth) return;
      const rutaServiciosEspecializados =
        loc.pathname === "/servicios-especializados" ||
        loc.pathname.startsWith("/servicios-especializados/");
      const esUsuarioServiciosEspecializados = cedulaUsuario === "4218167";

      if (rutaServiciosEspecializados && esUsuarioServiciosEspecializados) {
        return;
      }

      const permissions = loadModulePermissions();
      // Las rutas de un departamento de Solicitudes siguen la regla del hub
      // (incluye lo que dice EMSYS de los administrativos).
      const moduloRuta = getModuleByPath(loc.pathname);
      const departamento = DEPARTAMENTOS_SOLICITUDES.find(
        (d) => d.moduloPermiso === moduloRuta?.id,
      );
      if (departamento) {
        if (departamentoVisible(departamento, cargo, permissions)) return;
        // Entrada directa (p. ej. desde una push) antes de saber que dice
        // EMSYS: se pregunta antes de echarlo.
        if (departamento.cargarPermiso && departamento.permisoEnSesion?.() === null) {
          let vivo = true;
          departamento.cargarPermiso().then(() => {
            if (vivo && !departamentoVisible(departamento, cargo, loadModulePermissions())) {
              history.replace("/home");
            }
          });
          return () => {
            vivo = false;
          };
        }
        history.replace("/home");
        return;
      }

      if (!canAccessPath(loc.pathname, cargo, permissions)) {
        // Registro / historial de capacitaciones: los admins de Seguridad
        // (AE_C_Admin) no tienen un cargo propio; decide el backend.
        if (moduloRuta?.id === "registro_capacitacion" || moduloRuta?.id === "historial_capacitacion") {
          let vivo = true;
          RegistroCapacitacionAPI.miRol().then((rol) => {
            if (vivo && rol.tipos_admin.length === 0) history.replace("/home");
          });
          return () => {
            vivo = false;
          };
        }
        history.replace("/home");
      }
    }, [loc.pathname, isAuth, cargo, history, cedulaUsuario]);

    return null;
  };

  // Listener de mensajes del service worker: cuando llega una push y el usuario la toca,
  // el SW emite un postMessage tipo NAVIGATE para que el router SPA navegue al deep link.
  const PushNavigationHandler: React.FC = () => {
    const history = useHistory();
    useEffect(() => {
      if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
      console.log("[PushNav] listener montado");
      const onMessage = (event: MessageEvent) => {
        const data = (event && event.data) || {};
        console.log("[PushNav] mensaje SW recibido:", data);
        if (data && data.type === "NAVIGATE" && typeof data.url === "string" && data.url) {
          console.log("[PushNav] navegando a", data.url);
          history.push(data.url);
        }
      };
      navigator.serviceWorker.addEventListener("message", onMessage);
      return () => navigator.serviceWorker.removeEventListener("message", onMessage);
    }, [history]);
    return null;
  };

  const rutaPendienteKey = 'pending_route';
  const pendingNotifKey = 'pending_notif_tardanza';

  const normalizeRoute = (raw: string) => {
    try {
      const url = new URL(raw, window.location.origin);
      return `${url.pathname}${url.search}${url.hash}`;
    } catch {
      return raw;
    }
  };

  const isRutaPermitida = (pathname: string) => {
    const permitidas = [
      '/home',
      '/marcar',
      '/historial-de-trabajo',
      '/salarios',
      '/nosotros',
      '/documentaciones',
      '/denuncias',
      '/notificaciones/tardanza',
      '/gestion-ausencia',
      '/mis-casos',
    ];
    return permitidas.some((ruta) => pathname === ruta || pathname.startsWith(`${ruta}/`));
  };

  const PendingRouteHandler: React.FC<{ isAuth: boolean }> = ({ isAuth }) => {
    const ubicacion = useLocation();
    const history = useHistory();

    useEffect(() => {
      if (isAuth) return;
      if (ubicacion.pathname === '/login' || ubicacion.pathname === '/home') return;

      const query = ubicacion.search || '';
      const pending = `${ubicacion.pathname}${query}`;
      sessionStorage.setItem(rutaPendienteKey, pending);
    }, [isAuth, ubicacion.pathname, ubicacion.search]);

    useEffect(() => {
      if (!isAuth) return;
      const pending = sessionStorage.getItem(rutaPendienteKey);
      if (!pending) return;
      sessionStorage.removeItem(rutaPendienteKey);
      history.replace(pending);
    }, [history, isAuth]);

    return null;
  };

  const NotificationMessageHandler: React.FC<{ isAuth: boolean }> = ({ isAuth }) => {
    const ubicacion = useLocation();
    const history = useHistory();

    useEffect(() => {
      const handler = (event: MessageEvent) => {
        const data = event?.data || {};
        if (data.type !== 'OPEN_TARDANZA' || !data.url) return;

        const target = normalizeRoute(String(data.url));
        if (!isAuth) {
          sessionStorage.setItem(pendingNotifKey, target);
          return;
        }

        if (isRutaPermitida(ubicacion.pathname)) {
          if (target !== `${ubicacion.pathname}${ubicacion.search}${ubicacion.hash}`) {
            history.push(target);
          }
          return;
        }

        sessionStorage.setItem(pendingNotifKey, target);
      };

      if (navigator.serviceWorker?.addEventListener) {
        navigator.serviceWorker.addEventListener('message', handler);
      }

      return () => {
        if (navigator.serviceWorker?.removeEventListener) {
          navigator.serviceWorker.removeEventListener('message', handler);
        }
      };
    }, [history, isAuth, ubicacion.pathname, ubicacion.search, ubicacion.hash]);

    useEffect(() => {
      if (!isAuth) return;
      if (!isRutaPermitida(ubicacion.pathname)) return;
      const pending = sessionStorage.getItem(pendingNotifKey);
      if (!pending) return;
      sessionStorage.removeItem(pendingNotifKey);
      history.push(pending);
    }, [history, isAuth, ubicacion.pathname]);

    return null;
  };

  // Suscripción global: escucha expiración de sesión emitida por el interceptor de API
  useEffect(() => { // Configuramos el listener al montar el componente
    const handler = (ev: Event) => { // Handler del evento de expiración
      const custom = ev as CustomEvent<{ message?: string }>; // Convertimos a CustomEvent para leer detail
      const mensaje = custom?.detail?.message || 'Tu sesión ha expirado. Inicia nuevamente.'; // Mensaje a mostrar al usuario
      present({ message: mensaje, duration: 5000, color: 'warning' }); // Mostramos toast informativo
      removerSesion(); // Limpiamos cabeceras y estado de autenticación en memoria
      Storage.removeSesion(); // Eliminamos la sesión persistida en storage
      // No navegamos manualmente: el guard basado en isAuth redirige automáticamente a /login
    }; // Fin handler

    window.addEventListener(SESSION_EXPIRED_EVENT, handler); // Registramos el listener sobre window
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handler); // Limpiamos el listener al desmontar
  }, [present]); // Dependemos de present para evitar referencias obsoletas

  // Función para verificar la conectividad del backend
  const checkBackendConnectivity = async () => {
    try {
      // Mostrar información del backend en consola
      logBackendInfo();
      
      // Verificar salud del backend
      const health = await checkBackendHealth();
      
      console.log(`🔍 Estado del backend: ${health.status} (${health.statusCode}) - Conectado: ${health.isConnected}`);
      
      // Solo mostrar notificación si realmente hay problemas de conectividad
      if (!health.isConnected || (health.status === 'ERROR' && health.statusCode !== 403 && health.statusCode !== 401)) {
        console.error(`❌ Problemas de conectividad con el backend: ${health.error}`);
        
        // Diagnosticar problemas específicos
        const issues = await diagnoseBackendIssues();
        if (issues.length > 0) {
          console.error('🔍 Problemas detectados:', issues);
        }
        
        // Solo mostrar notificación si realmente no hay conectividad
        if (health.statusCode !== 403 && health.statusCode !== 401 && health.statusCode !== 400) {
          present({
            message: 'Problemas de conectividad con el servidor. Algunas funciones pueden no estar disponibles.',
            duration: 5000,
            color: 'warning'
          });
        }
      } else {
        console.log(`✅ Backend conectado exitosamente - Tiempo de respuesta: ${health.responseTime}ms`);
      }
    } catch (error) {
      console.error('Error al verificar conectividad del backend:', error);
    }
  };

  

  const cargarSesion = async () => {
    await Storage.getSesion().then(
      (sesion: Sesion | undefined) => {
        if (sesion) {
          agregarSesion(sesion);
        }
      },
      () => "Ocurrió un error al iniciar sesión"
    );
  };

  const agregarUsuario = (Sesion: Sesion) => {
    agregarSesion(Sesion);
    Storage.setSesion(Sesion);
  };

  const agregarSesion = (sesion: Sesion) => {
    api.defaults.headers.common["Authorization"] = sesion.token;
    // Sincronizamos también el token para el interceptor de axios
    localStorage.setItem('authToken', sesion.token);
    setIsAuth(true);
    cargarPerfilDeUsuario();
  };

  const cerrarSesion = () => {
    LoginAPI.logout()
      .then((response) => {
        present({ message: response.data.info, duration: 5000 });
      })
      .catch((error) => {
        present({
          message: error.response ? error.response.data.error : error,
          duration: 5000,
        });
      })
      .finally(() => {
        removerSesion();
        Storage.removeSesion();
      });
  };

  const removerSesion = () => {
    api.defaults.headers.common["Authorization"] = undefined;
    localStorage.removeItem('authToken');
    // Flag de admin de Recursos cacheado por sesión (ver Menu.tsx): si no se
    // limpia, el siguiente usuario en la misma pestaña hereda el menú del anterior.
    sessionStorage.removeItem('recursos_es_admin_session');
    sessionStorage.removeItem('sst_puede_solicitar_session');
    sessionStorage.removeItem('rrhh_puede_solicitar_session');
    sessionStorage.removeItem(CAPADM_ACCESO_KEY);
    sessionStorage.removeItem(AGENDA_ACCESO_KEY);
    sessionStorage.removeItem(CAPACITACION_PERMISO_SESSION_KEY);
    sessionStorage.removeItem(CAPACITACION_ROL_KEY);
    // Fiscal elegido por la gerente de Operaciones: no se hereda en la próxima sesión.
    guardarFiscalActuando(null);
    setIsAuth(false);
    setCargo(undefined);
    setUser("");
    setCedulaUsuario("");
  };

  const cargarPerfilDeUsuario = async () => {
    LoginAPI.me()
      .then((response) => {
        const usuario = response.data.datos;

        const apellidoYNombre = capitalize(usuario.emp_nombre);
        const [apellidos, nombres] = apellidoYNombre.split(", ");

        setUser(`${nombres} ${apellidos}`);
        setCargo(usuario.emp_cargo);
        setCedulaUsuario(String(usuario?.emp_cedula || ""));

        // Aviso de migración de servidor (solo para usuario TIC específico).
        // Objetivo: validar rápidamente que el frontend desplegado está apuntando al nuevo servidor.
        // Se muestra 1 vez por sesión de navegador para no ser intrusivo.
        try {
          const cedula = String(usuario?.emp_cedula ?? '');
          const NEW_SERVER_IP = '190.128.216.146';
          const key = `new_server_notice_${NEW_SERVER_IP}`;

          if (cedula === '5355286' && typeof sessionStorage !== 'undefined' && !sessionStorage.getItem(key)) {
            sessionStorage.setItem(key, '1');
            present({
              message: `NUEVO SERVER - ${NEW_SERVER_IP}`,
              duration: 8000,
              color: 'primary',
            });
          }
        } catch {
          // No interrumpir el flujo normal de carga de perfil.
        }
      })
      .catch(() => { });
  };

  const loginWithRedirect = isAuth ? (
    <Redirect to="/" />
  ) : (
    <Login agregarUsuario={agregarUsuario} />
  );

  const loginSiNoHaySesion = !isAuth ? <Redirect to="/login" /> : null;




  return (
    <IonApp>
      <IonLoading
        isOpen={swUpdating}
        message={'Actualizando...'}
        backdropDismiss={false}
      />
      <UpdateAvailableToast />
      <EnvironmentRibbon /> {/* mostrar tirita de ambiente en modo desarrollo */}
      <MuiPickersUtilsProvider
        libInstance={moment}
        utils={MomentUTCUtils}
        locale="es-mx"
      >
        <IonReactRouter>
          <RouteListener />
          <PushNavigationHandler />
          <EvaluacionGuard
            isAuth={isAuth}
            evalPendientes={evalPendientes}
            setEvalBloqueado={setEvalBloqueado}
            setEvalReapertura={setEvalReapertura}
            present={present}
          />
          <PerfilGuard
            isAuth={isAuth}
            needsUpdate={perfilNeedsUpdate}
            setPerfilBloqueado={setPerfilBloqueado}
            setPerfilReapertura={setPerfilReapertura}
            present={present}
          />
          <EventoEvaluacionGuard
            isAuth={isAuth}
            eventoEvalPendiente={eventoEvalPendiente}
            setEventoEvalBloqueado={setEventoEvalBloqueado}
            setEventoEvalReapertura={setEventoEvalReapertura}
            present={present}
          />
          <EventoRespuestaGuard
            isAuth={isAuth}
            eventoRespPendiente={eventoRespPendiente}
            setEventoRespBloqueado={setEventoRespBloqueado}
            setEventoRespReapertura={setEventoRespReapertura}
            present={present}
          />
          <PendingRouteHandler isAuth={isAuth} />
          <NotificationMessageHandler isAuth={isAuth} />
          <GestionAusenciaGuard
            isAuth={isAuth}
            gestionPendiente={gestionPendiente}
            present={present}
          />
          <DispositivoSeguroPrompt isAuth={isAuth} />
          <Switch>
            <Route exact path="/">
              <Redirect to={isAuth ? "/home" : "/login"} />
            </Route>

            <Route exact path="/login" render={() => loginWithRedirect} />

            {loginSiNoHaySesion}

            <Route path="/notificaciones/tardanza">
              <NotificacionTardanza />
            </Route>

            <Route path="/gestion-ausencia/:id">
              <GestionAusencia />
            </Route>

            <Route exact path="/atencion-cliente">
              <Menu
                contentId="atencion-cliente"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <AtcMisCitas />
            </Route>
            <Route exact path="/atencion-cliente/nueva">
              <Menu
                contentId="atencion-cliente"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <AtcNuevaCita />
            </Route>
            <Route exact path="/atencion-cliente/citas/:id/feedback">
              <Menu
                contentId="atencion-cliente"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <AtcFeedback />
            </Route>
            <Route exact path="/atencion-cliente/citas/:id">
              <Menu
                contentId="atencion-cliente"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <AtcDetalleCita />
            </Route>

            {/* Modulo Solicitudes: se elige el departamento y de ahi se
                entra a su flujo. Hoy el unico departamento es RRHH. */}
            <Route exact path="/solicitudes">
              <Menu
                contentId="solicitudes"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <Solicitudes cargo={cargo} />
            </Route>

            {/* Solicitudes a RRHH (migracion del proceso de Flokzu).
                /nueva va antes de /:id para que no lo capture como id. */}
            <Route exact path="/solicitudes-rrhh">
              <Menu
                contentId="solicitudes-rrhh"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <SolicitudesRRHHMis />
            </Route>
            <Route exact path="/solicitudes-rrhh/nueva">
              <Menu
                contentId="solicitudes-rrhh"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <SolicitudRRHHNueva />
            </Route>
            {/* Correccion de una devuelta: es el mismo formulario del
                alta, con lo que se habia cargado. Va antes de /:id para que
                no lo capture. */}
            <Route exact path="/solicitudes-rrhh/:id/corregir">
              <Menu
                contentId="solicitudes-rrhh"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <SolicitudRRHHNueva />
            </Route>
            <Route exact path="/solicitudes-rrhh/:id">
              <Menu
                contentId="solicitudes-rrhh"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <SolicitudRRHHDetalle />
            </Route>

            <Route path="/home">
              <Menu
                contentId="home"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <Home />
            </Route>

            <Route path="/actualizar-datos">
              <Menu
                contentId="home"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <ActualizarDatos />
            </Route>

            <Route path="/historial-de-trabajo">
              <HistorialConFiltro
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
            </Route>

            <Route path="/mis-asignaciones">
              <Menu
                contentId="mis-asignaciones"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <MisAsignaciones />
            </Route>

            <Route path="/mis-reemplazos">
              <Menu
                contentId="mis-reemplazos"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <MisReemplazos />
            </Route>

            <Route path="/notificacion-reemplazos">
              <Menu
                contentId="notificacion-reemplazos"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <NotificacionReemplazos />
            </Route>

            <Route path="/reporte-reemplazos-contact">
              <Menu
                contentId="reporte-reemplazos-contact"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <ReporteReemplazosContact />
            </Route>

            <Route exact path="/mensajes">
              <Menu
                contentId="mensajes"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <Mensajes />
            </Route>

            <Route path="/mensajes/:id">
              <Menu
                contentId="mensajes"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <ChatConversacion />
            </Route>

            <Route path="/reclamos/procesar">
              <ReclamosProceso
                cargo={cargo}
                cerrarSesion={cerrarSesion} />
            </Route>

            <Route path="/reclamos">
              <ReclamosConFiltro
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
            </Route>

            <Route path="/marcar">
              <Menu
                contentId="reclamos"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <Marcaciones />
            </Route>

            <Route path="/salarios">
              <Menu
                contentId="salarios"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <RecibosSalariales />
            </Route>

            <Route exact path="/reembolsos-pasajes">
              <Menu
                contentId="reembolsos-pasajes"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <ReembolsosPasajes />
            </Route>

            <Route exact path="/reembolsos-pasajes/detalle/:id">
              <Menu
                contentId="reembolso-pasaje-detalle"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <ReembolsoPasajeDetalle />
            </Route>

            <Route exact path="/reembolsos-pasajes/reclamar">
              <Menu
                contentId="reembolso-pasaje-reclamo"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <ReembolsoPasajeReclamo />
            </Route>

            <Route path="/clima-organizacional">
              <Menu
                contentId="clima-organizacional"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <ClimaOrganizacional />
            </Route>

            <Route path="/mi-perfil">
              <Menu
                contentId="home"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <MiPerfil cerrarSesion={cerrarSesion} />
            </Route>

            {/* Entregas Masivas - Mi QR (visible para todo colaborador autenticado) */}
            <Route path="/entregas-masivas/mi-qr">
              <MiQREntrega />
            </Route>

            {/* Entregas Masivas - Registro (QR o manual, entregadores y admins) */}
            <Route path="/entregas-masivas/registrar">
              <RegistrarEntrega />
            </Route>

            {/* Entregas Masivas - Mi stock (saldo, transferencias, recepcion) */}
            <Route path="/entregas-masivas/mi-stock">
              <MiStock />
            </Route>

            {/* Entregas Masivas - Administracion (admins de AE_EntregasMasivas_Admins,
                validado en backend). Mientras se resuelve el rol no redirigimos para
                no expulsar a un admin válido antes de tener la respuesta. */}
            <Route path="/entregas-masivas/admin">
              {esAdminEntregasMasivas === false ? (
                <Redirect to="/" />
              ) : esAdminEntregasMasivas ? (
                <AdminEntregasMasivas />
              ) : null}
            </Route>

            <Route exact path="/settings">
              <Menu
                contentId="home"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <Settings />
            </Route>

            <Route path="/settings/modulos">
              <Menu
                contentId="home"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <ModulePermissions />
            </Route>


            <Route path="/gestionMarcacionSalida">
              {({ location }) => {
                const info: any = location.state || {};

                return (
                  <GestionMarcacionSalida info={info} />
                );
              }}
            </Route>
            <Route path="/gestionMarcacionEntrada">
              {({ location }) => {
                const info: any = location.state || {};

                return (
                  <GestionMarcacionEntrada info={info} />
                );
              }}
            </Route>
            <Route path="/gestionMarcacionSupera">
              {({ location }) => {
                const info: any = location.state || {};

                return (
                  <GestionMarcacionSupera info={info} />
                );
              }}
            </Route>
            {/* <Route path="/gestionTipoHoraProcesada">
              {({ location }) => {
                const info: any = location.state || {};

                return (
                  <GestionTipoHoraView info={info} />
                );
              }}
            </Route> */}

            <Route path="/marcacion">
              <Marcacion />
            </Route>

            <Route path="/horasprocesadas">
              <HorasProcesadas />
            </Route>


            <Route path="/gestiones">
              <Menu
                contentId="gestiones"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              {/* Asignacion fue la primera implementacion lo que ahora corresponde a "gestiones". 
              Si se cambia el nombre puede causar un error en la llamada al componente "asignaion" */}
              <Asignacion
                cargo={cargo} />
            </Route>

            {/* Ruta del nuevo módulo Acompañamiento: índice/cascarón */}
            <Route exact path="/acompanamiento"> {/* Definimos la ruta principal del módulo y la marcamos exacta */}
              {/* Guardia de acceso por cargo */}
              {(() => {
                const cargoTxt = cargo || ''; // Normalizamos el cargo
                const esJefeOperaciones = cargoTxt.includes('JEFE DE OPERACIONES') || cargoTxt.includes('JEFE DE OPE') || esGerenteDeOperaciones(cargoTxt); // Permisos (gerente de Operaciones incluida)
                const esTic = cargoTxt.includes('TIC'); // Permisos
                const esDevFront = cargoTxt.includes('DESARROLLADOR FRONT END'); // Permisos
                const esGerenteTI = cargoTxt.includes('GERENTE DE TECNOLOGIAS DE LA INFORMACION'); // Permisos
                if (!(esJefeOperaciones || esTic || esDevFront || esGerenteTI)) { // Si no tiene permisos
                  return <Redirect to="/" />; // Redirigimos al inicio
                }
                return null; // Si tiene permisos, seguimos renderizando
              })()}

              <Menu
                contentId="acompanamiento" // contentId único para esta ruta
                user={user} // Nombre del usuario para el menú
                cargo={cargo ?? undefined} // Cargo opcional
                cerrarSesion={cerrarSesion} // Acción de salir
              />

              <Acompanamiento
                user={user} // Fiscal mostrado en el encabezado
                cargo={cargo ?? undefined} // Cargo opcional
              />
            </Route>

            {/* Ruta del formulario de Acompañamiento */}
            <Route path="/acompanamiento/nuevo"> {/* Formulario de creación */}
              {/* Guardia de acceso por cargo */}
              {(() => {
                const cargoTxt = cargo || ''; // Normalizamos
                const esJefeOperaciones = cargoTxt.includes('JEFE DE OPERACIONES') || cargoTxt.includes('JEFE DE OPE') || esGerenteDeOperaciones(cargoTxt); // Permisos (gerente de Operaciones incluida)
                const esTic = cargoTxt.includes('TIC'); // Permisos
                const esDevFront = cargoTxt.includes('DESARROLLADOR FRONT END'); // Permisos
                const esGerenteTI = cargoTxt.includes('GERENTE DE TECNOLOGIAS DE LA INFORMACION'); // Permisos
                if (!(esJefeOperaciones || esTic || esDevFront || esGerenteTI)) { // Sin permisos
                  return <Redirect to="/" />; // Redirigimos
                }
                return null; // Permitir render
              })()}

              <Menu
                contentId="acompanamiento" // Reutilizamos el mismo contentId
                user={user} // Usuario para el encabezado
                cargo={cargo ?? undefined} // Cargo opcional
                cerrarSesion={cerrarSesion} // Salir
              />

              {/* Importamos dinámicamente para mantener orden de imports arriba */}
              <AcompanamientoForm user={user} /> {/* Pasamos el usuario como Fiscal */}
            </Route>

            {/* Ruta del módulo Entrega de Folleto (Reporte de Sostenibilidad) */}
            <Route exact path="/entrega-folleto">
              {/* Guardia de acceso: solo Ejecutivos Comerciales */}
              {(() => {
                const cargoTxt = (cargo || '').toUpperCase();
                if (!cargoTxt.includes('EJECUTIVO COMERCIAL')) {
                  return <Redirect to="/" />;
                }
                return null;
              })()}

              <Menu
                contentId="entrega-folleto"
                user={user}
                cargo={cargo ?? undefined}
                cerrarSesion={cerrarSesion}
              />

              <EntregaFolleto user={user} cargo={cargo ?? undefined} />
            </Route>

            <Route path="/asignacionDetalle">
              <AsignacionDetalle
                cargo={cargo}
              />

            </Route>

            <Route path="/AsignacionDTEdicion">
              <AsignacionDTEdicion
                cargo={cargo}
              />
            </Route>

            <Route path="/nosotros">
              <Menu
                contentId="nosotros"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <Nosotros />
            </Route>

            <Route path="/documentaciones">
              <Menu
                contentId="documentaciones"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <Documentaciones />
            </Route>

            {/* Nuevo módulo: Reemplazos (nuevo) - mantiene backend existente */}
            <Route path="/reemplazos-v2">
              <Menu
                contentId="reemplazos-v2"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <ReemplazosV2 />
            </Route>

            {/* "Gestión Marcación (nuevo)" se unificó en Gestión de Errores (pestaña Pendientes) */}
            <Route path="/gestion-marcacion-v2">
              <Redirect to="/gestion-errores?tab=pendientes" />
            </Route>

            {/* Nuevo módulo: Asignaciones (nuevo) estilo EMSYS - mantiene backend existente */}
            <Route exact path="/asignaciones-v2">
              <Menu
                contentId="asignaciones-v2"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <AsignacionesV2 />
            </Route>
            <Route exact path="/asignaciones-v2-detalle">
              <Menu
                contentId="asignaciones-v2-detalle"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <AsignacionesV2Detalle />
            </Route>

            {/* Home del módulo: listado */}
            <Route exact path="/evaluacion-de-desempeno"> {/* listado inicial del módulo */}
              {/* Guardia de acceso por roles específicos */}
              {(() => { // evaluar permisos de acceso antes de renderizar
                const cargoTxt = cargo || ""; // obtener texto del cargo o vacío
                const cargoNorm = cargoTxt.toLowerCase(); // normalizar a minúsculas para comparaciones
                const esFiscal = cargoNorm.includes("fiscal"); // permitir a fiscales
                const esJefeOperaciones = cargoTxt.includes("JEFE DE OPERACIONES") || cargoTxt.includes("JEFE DE OPE"); // permitir a jefes de operaciones
                const esSupervisor = cargoNorm.includes("supervisor"); // permitir a supervisores
                const esLider = cargoNorm.includes("lider") || cargoTxt.includes("LIDER AGENTIS"); // permitir a líderes
                const esGerenteOperaciones = cargoTxt === "GERENTE DE OPERACIONES" || cargoTxt === "GERENTE DE OPERACIONES - UNIDADES ESPECIALIZADAS"; // permitir a gerentes de operaciones
                const esTic = cargoTxt.includes("TIC"); // permitir a TIC
                const esGerenteTI = cargoTxt.includes("GERENTE DE TECNOLOGIAS DE LA INFORMACION"); // permitir a gerencia de TI
                const permitido = EVALUACION_SOLO_TIC
                  ? esTic
                  : (esFiscal || esJefeOperaciones || esSupervisor || esLider || esGerenteOperaciones || esTic || esGerenteTI); // consolidar reglas según flag
                if (!permitido) return <Redirect to="/" />; // si no está permitido, redirigir al inicio
                return null; // si está permitido, continuar
              })()}

              <Menu
                contentId="evaluacion-de-desempeno-home" // debe coincidir con el id del IonContent de la vista home
                user={user} // pasar nombre de usuario al menú
                cargo={cargo} // pasar cargo para lógica condicional del menú
                cerrarSesion={cerrarSesion} // acción para cerrar sesión
              />

              <EvaluacionDesempenoHome /> {/* listado de evaluaciones */}
            </Route>

            {/* Nuevo: ruta del formulario "Nuevo" */}
            <Route path="/evaluacion-de-desempeno/nuevo">
              {/* Reutilizamos la misma guardia de roles */}
              {(() => {
                const cargoTxt = cargo || "";
                const cargoNorm = cargoTxt.toLowerCase();
                const esFiscal = cargoNorm.includes("fiscal");
                const esJefeOperaciones = cargoTxt.includes("JEFE DE OPERACIONES") || cargoTxt.includes("JEFE DE OPE");
                const esSupervisor = cargoNorm.includes("supervisor");
                const esLider = cargoNorm.includes("lider") || cargoTxt.includes("LIDER AGENTIS");
                const esGerenteOperaciones = cargoTxt === "GERENTE DE OPERACIONES" || cargoTxt === "GERENTE DE OPERACIONES - UNIDADES ESPECIALIZADAS";
                const esTic = cargoTxt.includes("TIC");
                const esGerenteTI = cargoTxt.includes("GERENTE DE TECNOLOGIAS DE LA INFORMACION");
                const permitido = EVALUACION_SOLO_TIC
                  ? esTic
                  : (esFiscal || esJefeOperaciones || esSupervisor || esLider || esGerenteOperaciones || esTic || esGerenteTI);
                if (!permitido) return <Redirect to="/" />;
                return null;
              })()}

              <Menu
                contentId="evaluacion-de-desempeno" // coincide con el id del IonContent del formulario
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <EvaluacionDesempeno /> {/* formulario de creación */}
            </Route>

            {/* Detalle de Evaluación de Desempeño */}
            <Route path="/evaluacion-de-desempeno/reporte">
              <Menu
                contentId="evaluacion-de-desempeno-reporte"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <EvaluacionDesempenoReporte />
            </Route>

            {/* Detalle de Evaluación de Desempeño */}
            <Route path="/evaluacion-de-desempeno/:id">
              <Menu
                contentId="evaluacion-de-desempeno-detalle" // coincide con el id del IonContent del detalle
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <EvaluacionDesempenoDetalle />
            </Route>

            <Route path="/evaluacion-visitas">
              {(() => {
                const cargoTxt = cargo || "";
                const cargoNorm = cargoTxt.toLowerCase();
                const esDesarrollador = cargoNorm.includes("desarrollador");
                const esJefeOperaciones = cargoTxt.includes("JEFE DE OPERACIONES") || cargoTxt.includes("JEFE DE OPE");
                const esGerenteOperaciones = cargoTxt === "GERENTE DE OPERACIONES" || cargoTxt === "GERENTE DE OPERACIONES - UNIDADES ESPECIALIZADAS";
                const esGerenteGeneralAdjunto = cargoNorm.includes("gerente general adjunto");
                const permitido = esDesarrollador || esJefeOperaciones || esGerenteOperaciones || esGerenteGeneralAdjunto;
                if (!permitido) return <Redirect to="/" />;
                return null;
              })()}

              <Menu
                contentId="evaluacion-visitas"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <EvaluacionVisitas />
            </Route>

            <Route path="/evaluacion-reconocimiento">
              {(() => {
                const cargoNorm = (cargo || "").toLowerCase();
                const permitido =
                  cargoNorm.includes("desarrollador") ||
                  cargoNorm.includes("fiscal") ||
                  cargoNorm.includes("jefe de operaciones") ||
                  cargoNorm.includes("jefe de ope") ||
                  cargoNorm.includes("gerente de operaciones");
                if (!permitido) return <Redirect to="/" />;
                return null;
              })()}

              <Menu
                contentId="evaluacion-reconocimiento"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <EvaluacionReconocimiento />
            </Route>

            <Route path="/relevamiento-visitas">
              <Menu
                contentId="relevamiento-visitas"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <RelevamientoVisitas />
            </Route>

            <Route path="/visitas-unidades-especializadas">
              <Menu
                contentId="visitas-unidades-especializadas"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <VisitasUnidadesEspecializadas />
            </Route>

            {/* Relevamiento Operativo (fiscales) */}
            <Route exact path="/relevamiento-operativo">
              {(() => {
                const esFiscal = (cargo || "").toLowerCase().includes("fiscal") || esGerenteDeOperaciones(cargo);
                const esDev = (cargo || "").toLowerCase().includes("desarrollador");
                if (!esFiscal && !esDev) return <Redirect to="/" />;
                return null;
              })()}
              <Menu
                contentId="relevamiento-operativo"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <RelevamientoOperativoListado />
            </Route>

            <Route exact path="/relevamiento-operativo/nuevo">
              {(() => {
                const esFiscal = (cargo || "").toLowerCase().includes("fiscal") || esGerenteDeOperaciones(cargo);
                const esDev = (cargo || "").toLowerCase().includes("desarrollador");
                if (!esFiscal && !esDev) return <Redirect to="/" />;
                return null;
              })()}
              <Menu
                contentId="relevamiento-operativo"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <RelevamientoOperativo />
            </Route>

            <Route exact path="/relevamiento-operativo/editar/:id">
              {(() => {
                const esFiscal = (cargo || "").toLowerCase().includes("fiscal") || esGerenteDeOperaciones(cargo);
                const esDev = (cargo || "").toLowerCase().includes("desarrollador");
                if (!esFiscal && !esDev) return <Redirect to="/" />;
                return null;
              })()}
              <Menu
                contentId="relevamiento-operativo"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <RelevamientoOperativo />
            </Route>

            {/* Orden de Trabajo (fiscales) */}
            <Route exact path="/orden-trabajo">
              {(() => {
                const esFiscal = (cargo || "").toLowerCase().includes("fiscal") || esGerenteDeOperaciones(cargo);
                const esDev = (cargo || "").toLowerCase().includes("desarrollador");
                if (!esFiscal && !esDev) return <Redirect to="/" />;
                return null;
              })()}
              <Menu
                contentId="orden-trabajo"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <OrdenTrabajo />
            </Route>

            {/* Rutinas de limpieza (fiscales y jefes de operaciones) - TD-11191 */}
            <Route exact path="/rutinas">
              {(() => {
                // Mientras se recupera la sesión (recarga o deep link) no se redirige.
                if (cargo === undefined) return null;
                const c = (cargo || "").toLowerCase();
                const puede = c.includes("fiscal") || c.includes("desarrollador") || c.includes("jefe de ope");
                if (!puede) return <Redirect to="/" />;
                return (
                  <>
                    <Menu
                      contentId="rutinas"
                      user={user}
                      cargo={cargo}
                      cerrarSesion={cerrarSesion}
                    />
                    <Rutinas />
                  </>
                );
              })()}
            </Route>

            {/* Mi Rutina (operarios): el backend resuelve titular / reemplazante */}
            <Route exact path="/mi-rutina">
              <Menu
                contentId="mi-rutina"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <MiRutina />
            </Route>

            {/* Recursos: biblioteca de capacitaciones y material.
                Sin guarda por cargo: el backend decide qué ve cada uno segun la
                audiencia de cada recurso (global o por cargos elegidos). */}
            <Route exact path="/recursos">
              <Menu
                contentId="recursos"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <Recursos />
            </Route>

            {/* Administracion de Recursos. La habilitacion real es la tabla
                AE_Recurso_Admin; la pagina la consulta al montarse. */}
            <Route exact path="/recursos/admin">
              <Menu
                contentId="recursos-admin"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <RecursosAdmin />
            </Route>


            {/* Evaluacion a Capacitaciones Tecnicas */}
            <Route path="/evaluacion-capacitacion">
              {(() => {
                const cargoTxt = cargo || '';
                const esFiscal = (cargoTxt.toLowerCase() || '').includes('fiscal') || esGerenteDeOperaciones(cargoTxt);
                const esTic = cargoTxt.includes('TIC');
                const permitido = esFiscal;
                if (!permitido) return <Redirect to='/' />;
                return null;
              })()}

              <Menu
                contentId="evaluacion-capacitacion"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <EvaluacionCapacitacion />
            </Route>

            {/* Sugerencia por Geolocalizacion: gerente, jefes, analista y fiscales */}
            <Route path="/sugerencia-ps">
              {/* Hasta que llega el perfil el cargo es undefined: no redirigir todavia. */}
              {cargo !== undefined && !puedeVerSugerenciaPs(cargo) && <Redirect to='/' />}
              <Menu
                contentId="sugerencia-ps"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <SugerenciaPs />
            </Route>

            {/* Asignaciones - solo lectura para Capacitador Tecnico y Jefe de Operaciones */}
            <Route path="/asignaciones-capacitador">
              {(() => {
                const cargoTxt = (cargo || '').toUpperCase();
                const esCapacitador =
                  cargoTxt.includes('CAPACITADOR TECNICO') ||
                  cargoTxt.includes('COORDINADOR DE CAPACITACIONES TECNICAS');
                // 'JEFE DE OPE' cubre el cargo truncado que existe en produccion.
                const esJefeOperaciones = cargoTxt.includes('JEFE DE OPERACIONES') || cargoTxt.includes('JEFE DE OPE') || esGerenteDeOperaciones(cargoTxt);
                if (!(esCapacitador || esJefeOperaciones)) return <Redirect to='/' />;
                return null;
              })()}

              <Menu
                contentId="asignaciones-capacitador"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <AsignacionesCapacitador />
            </Route>

            {/* Registro de Capacitacion (Tecnica: capacitador tecnico y coordinador;
                Seguridad: admins de Seguridad de AE_C_Admin) */}
            <Route path="/registro-capacitacion">
              {(() => {
                const cargoTxt = (cargo || '').toUpperCase();
                const permitido =
                  cargoTxt.includes('CAPACITADOR TECNICO') ||
                  cargoTxt.includes('COORDINADOR DE CAPACITACIONES TECNICAS') ||
                  // Sin respuesta todavía: no se lo echa (el backend igual valida).
                  rolCapacitacion === null ||
                  rolCapacitacion.tipos_registro.length > 0;
                if (!permitido) return <Redirect to='/' />;
                return null;
              })()}

              <Menu
                contentId="registro-capacitacion"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <RegistroCapacitacion />
            </Route>

            {/* Solicitudes de Capacitación (GT): fiscales, supervisores, jefes de
                operaciones y administrativos solicitan, el capacitador técnico
                asignado cierra. La coordinación va en EMSYS. A los
                administrativos los habilita api-central (permiso en sesión). */}
            <Route exact path="/solicitudes-capacitacion">
              {(() => {
                const c = (cargo || "").toLowerCase().replace(/é/g, "e");
                const permitido =
                  c.includes("fiscal") ||
                  esGerenteDeOperaciones(cargo) ||
                  c.includes("supervisor") ||
                  c.includes("jefe de ope") ||
                  c.includes("desarrollador") ||
                  (c.includes("capacitador") && c.includes("tecnic")) ||
                  // Sin respuesta todavia (entrada directa): RouteListener lo
                  // pide y lo echa si no corresponde.
                  permisoCapacitacionEnSesion() !== false;
                if (!permitido) return <Redirect to="/" />;
                return null;
              })()}
              <Menu
                contentId="solicitudes-capacitacion"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <SolicitudesCapacitacion />
            </Route>

            {/* Cierre de una capacitación asignada (capacitador técnico). */}
            <Route exact path="/solicitudes-capacitacion/:id/cierre">
              {(() => {
                const c = (cargo || "").toLowerCase().replace(/é/g, "e");
                const permitido = c.includes("desarrollador") || (c.includes("capacitador") && c.includes("tecnic"));
                if (!permitido) return <Redirect to="/" />;
                return null;
              })()}
              <Menu
                contentId="solicitud-capacitacion-cierre"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <SolicitudCapacitacionCierre />
            </Route>

            {/* SST: acciones correctivas de Levantamientos de Condiciones Inseguras.
                Cualquier colaborador puede ser asignado desde EMSYS, asi que no se
                filtra por cargo: EMSYS solo devuelve los asignados a su cedula. */}
            <Route exact path="/sst/acciones-correctivas">
              <Menu contentId="sst-acciones-correctivas" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <AccionesCorrectivas />
            </Route>
            <Route exact path="/sst/acciones-correctivas/:id">
              <Menu contentId="sst-accion-correctiva" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <AccionCorrectivaDetalle />
            </Route>

            {/* Solicitudes a SST (Solicitudes > SST). Quien la ve lo decide el modulo
                solicitudes_sst de modulePermissions; SST las gestiona en EMSYS. */}
            <Route exact path="/sst/solicitudes">
              <Menu contentId="sst-solicitudes" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <SolicitudesSst />
            </Route>
            <Route exact path="/sst/solicitudes/:id">
              <Menu contentId="sst-solicitud-detalle" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <SolicitudSstDetalle />
            </Route>

            {/* Solicitudes a GafCORE (Solicitudes > GafCORE): se elige Traslados o Mantenimientos.
                Quien las ve lo decide solicitudes_gafcore de modulePermissions; las atiende GAF. */}
            <Route exact path="/gafcore">
              <Menu contentId="gafcore-menu" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <SolicitudesGafcoreMenu />
            </Route>
            <Route exact path="/gafcore/mantenimientos">
              <Menu contentId="gafcore-mantenimientos" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <SolicitudesMantenimiento />
            </Route>
            <Route exact path="/gafcore/mantenimientos/:id">
              <Menu contentId="gafcore-mantenimiento-detalle" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <SolicitudMantenimientoDetalle />
            </Route>
            <Route exact path="/gafcore/solicitudes">
              <Menu contentId="gafcore-solicitudes" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <SolicitudesGafcore />
            </Route>
            <Route exact path="/gafcore/solicitudes/:id">
              <Menu contentId="gafcore-solicitud-detalle" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <SolicitudGafcoreDetalle />
            </Route>

            {/* Historial de Capacitaciones - para Capacitador, Coordinador y Fiscales */}
            <Route path="/historial-capacitacion">
              {(() => {
                const cargoTxt = (cargo || '').toUpperCase();
                const permitido =
                  cargoTxt.includes('CAPACITADOR TECNICO') ||
                  cargoTxt.includes('COORDINADOR DE CAPACITACIONES TECNICAS') ||
                  cargoTxt.includes('FISCAL') ||
                  esGerenteDeOperaciones(cargoTxt) ||
                  rolCapacitacion === null ||
                  rolCapacitacion.tipos_registro.length > 0;
                if (!permitido) return <Redirect to='/' />;
                return null;
              })()}

              <Menu
                contentId="historial-capacitacion"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <HistorialCapacitacion cargo={cargo} />
            </Route>

            {/* Mantenimiento de temas / evaluaciones de Capacitaciones: admins del
                tipo (AE_C_Admin). :tipo = tecnica | seguridad */}
            <Route exact path="/capacitaciones/mantenimiento/:tipo">
              <GuardMantenimientoCapacitacion rol={rolCapacitacion} />
              <Menu contentId="capacitacion-mantenimiento" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <CapacitacionMantenimiento />
            </Route>
            <Route exact path="/capacitaciones/mantenimiento/:tipo/tema/:id">
              <GuardMantenimientoCapacitacion rol={rolCapacitacion} />
              <Menu contentId="capacitacion-tema-evaluacion" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <CapacitacionTemaEvaluacion />
            </Route>

            <Route path="/fiscalizacion">
              <Menu
                contentId="fiscalizacion"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <Fiscalizacion />
            </Route>
            <Route path="/asignacion-recursos">
              {(() => {
                const cargoTxt = cargo || '';
                const esFiscal = (cargoTxt.toLowerCase() || '').includes('fiscal') || esGerenteDeOperaciones(cargoTxt);
                if (!esFiscal) return <Redirect to='/' />;
                return null;
              })()}

              <Menu
                contentId="asignacion-recursos"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <AsignacionRecursos />
            </Route>
            <Route path="/mis-casos">
              {(() => {
                const cargoTxt = cargo || '';
                const esFiscal = (cargoTxt.toLowerCase() || '').includes('fiscal') || esGerenteDeOperaciones(cargoTxt);
                if (!esFiscal) return <Redirect to='/' />;
                return null;
              })()}

              <Menu
                contentId="mis-casos"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <MisCasosFiscal />
            </Route>
            <Route path="/fiscalizarinicio/:puntoservicio_id/:nombre/:codigo" >
              <Menu
                contentId="fiscalizacion"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <FiscalizarInicio />
            </Route>
            <Route path="/fiscalizarpersonal/:ps_id/:nombre/:codigo/:fis_id/:objetivo/:cod_id">
              <Menu
                contentId="fiscalizacion"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <FiscalizarPersonal />
            </Route>
            <Route path="/fiscalizardeposito/:ps_id/:nombre/:codigo/:fis_id/:objetivo/:cod_id">
              <Menu
                contentId="fiscalizacion"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <FiscalizarDeposito />
            </Route>
            <Route path="/fiscalizarmaquina/:ps_id/:nombre/:codigo/:fis_id/:objetivo/:cod_id">
              <Menu
                contentId="fiscalizacion"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <FiscalizarMaquina />
            </Route>
            <Route path="/fiscalizarlimpieza/:ps_id/:nombre/:codigo/:fis_id/:objetivo/:cod_id">
              <Menu
                contentId="fiscalizacion"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <FiscalizarLimpieza />
            </Route>
            <Route path="/fiscalizaropinion/:ps_id/:nombre/:codigo/:fis_id/:objetivo/:cod_id">
              <Menu
                contentId="fiscalizacion"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <FiscalizarOpinion />
            </Route>
            <Route path="/fiscalizarstock/:ps_id/:nombre/:codigo/:fis_id/:objetivo/:cod_id">
              <Menu
                contentId="fiscalizacion"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <FiscalizarStock />
            </Route>
            <Route path="/resumenfiscalizacion/:ps_id/:nombre/:codigo/:fis_id/:objetivo">
              <Menu
                contentId="fiscalizacion"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <ResumenFiscalizacion />
            </Route>
            <Route exact path="/planificacion-visitas">
              {(() => {
                return (
                  <>
                    <Menu
                      contentId="planificacion-visitas"
                      user={user}
                      cargo={cargo}
                      cerrarSesion={cerrarSesion}
                    />
                    <PlanificacionVisitas />
                  </>
                );
              })()}
            </Route>


            <Route path="/cierre-diario">
              <Menu
                contentId="cierre-diario"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <CierreDiario />
            </Route>

            <Route path="/CierreDiario/:ps_id/:fecha">
              <Menu
                contentId="Cierre Diario"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <CierreDiarioOperarios />
            </Route>

            <Route path="/CierreDiarioMensajeRechazo/:ps_id/:fecha">
              <Menu
                contentId="Cierre Diario"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <CierreDiarioOperarios />
            </Route>

            <Route path="/denuncias">
              <Menu
                contentId="denuncias"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />

              <Denuncias />
            </Route>

            <Route path="/pedido-de-productos">
            <Menu
                contentId="pedido-de-productos"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <PedidoDeProductos />
            </Route>

            <Route path="/pedido-de-productos-detalles" render={(props) => <PedidoDeProductosDetalle {...props} />}>
            <Menu
                contentId="pedido-de-productos"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <PedidoDeProductosDetalle />
            </Route>

            <Route path="/mis-pedidos">
              <Menu
                contentId="mis-pedidos"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <MisPedidos />
            </Route>

            <Route path="/limpiezas-profundas" exact>
            <Menu
                contentId="limpiezas-profundas"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <LimpiezasProfundas />
            </Route>

            <Route path="/limpiezas-profundas/:planId">
            <Menu
                contentId="limpiezas-profundas"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <LimpiezasProfundasDetalle />
            </Route>
            

            <Route path="/comunicados">
            <Menu
                contentId="comunicados"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <Comunicados />
            </Route>

            <Route path="/gestion-errores" exact>
              <Menu
                contentId="gestion-errores"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <GestionErrores />
            </Route>

            <Route path="/gestion-errores/:psId" exact>
              <Menu
                contentId="gestion-errores"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <GestionErroresDetalle />
            </Route>

            <Route exact path="/servicios-especializados">
              <Menu
                contentId="servicios-especializados"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <ServiciosEspecializados />
            </Route>

            <Route path="/servicios-especializados/:id">
              <Menu
                contentId="servicios-especializados"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <ServiciosEspecializadosDetalle />
            </Route>

            {/* Módulo de Eventos - Administración (solo admins del módulo, validado en backend) */}
            <Route path="/eventos/admin">
              <Menu
                contentId="eventos-admin"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <EventosAdmin />
            </Route>

            {/* Módulo de Eventos - Tomar asistencia (tomadores designados, validado en backend) */}
            <Route path="/eventos/asistencia">
              <Menu
                contentId="eventos-asistencia"
                user={user}
                cargo={cargo}
                cerrarSesion={cerrarSesion}
              />
              <EventoAsistencia />
            </Route>

            {/* Capacitaciones Administrativas (TD-11629). Anfitrion = padron
                administrativo (validado en backend, cada uno ve solo las suyas). */}
            <Route exact path="/capacitaciones-adm">
              <Menu contentId="capacitaciones-adm" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <CapacitacionesAdm />
            </Route>
            <Route exact path="/capacitaciones-adm/nueva">
              <Menu contentId="capacitaciones-adm-form" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <CapacitacionAdmForm />
            </Route>
            {/* Participante: escanear QR, pendientes e historial (cualquier funcionario) */}
            <Route exact path="/capacitaciones-adm/mis">
              <Menu contentId="capacitaciones-adm-mis" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <CapacitacionAdmMis />
            </Route>
            <Route exact path="/capacitaciones-adm/:id(\d+)/editar">
              <Menu contentId="capacitaciones-adm-form" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <CapacitacionAdmForm />
            </Route>
            <Route exact path="/capacitaciones-adm/:id(\d+)">
              <Menu contentId="capacitaciones-adm-detalle" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <CapacitacionAdmDetalle />
            </Route>

            {/* Agendamientos (TD-11766). Usuario: agendas segun su publico (filtra el
                backend). Gestion: admins (AE_Agenda_Admin), gestores y responsables. */}
            <Route exact path="/agenda">
              <Menu contentId="agenda-usuario" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <AgendaUsuario />
            </Route>
            <Route exact path="/agenda/tema/:id(\d+)">
              <Menu contentId="agenda-reservar" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <AgendaReservar />
            </Route>
            <Route exact path="/agenda/gestion">
              <Menu contentId="agenda-gestion" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <AgendaGestion />
            </Route>
            <Route exact path="/agenda/gestion/nueva">
              <Menu contentId="agenda-tema-form" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <AgendaTemaForm />
            </Route>
            <Route exact path="/agenda/gestion/:id(\d+)/editar">
              <Menu contentId="agenda-tema-form" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <AgendaTemaForm />
            </Route>
            <Route exact path="/agenda/gestion/:id(\d+)">
              <Menu contentId="agenda-tema-detalle" user={user} cargo={cargo} cerrarSesion={cerrarSesion} />
              <AgendaTemaDetalle />
            </Route>

            <Redirect to="/" />
          </Switch>
          <ChatFloatingButton isAuth={isAuth} cargo={cargo} />
          <GerenteFiscalSelector isAuth={isAuth} cargo={cargo} />
          <EvaluacionPendienteModal
            isAuth={isAuth}
            onPendientesChange={setEvalPendientes}
            bloqueado={evalBloqueado}
            solicitudReapertura={evalReapertura}
          />
          <EventoEvaluacionModal
            isAuth={isAuth}
            onPendienteChange={setEventoEvalPendiente}
            bloqueado={eventoEvalBloqueado}
            solicitudReapertura={eventoEvalReapertura}
          />
          <EventoRespuestaModal
            isAuth={isAuth}
            onPendienteChange={setEventoRespPendiente}
            bloqueado={eventoRespBloqueado}
            solicitudReapertura={eventoRespReapertura}
          />
          {/* Microencuesta de Selección e Inducción: el backend decide la
              elegibilidad (operario/a nuevo según FechaInicio del DWH). */}
          <MicroEncuestaModal isAuth={isAuth} />
          {/* Capacitaciones Administrativas: confirmaciones de participacion y
              evaluaciones pendientes. No bloquea: "Mas tarde" y vuelve al proximo inicio. */}
          <CapacitacionAdmPendientesModal isAuth={isAuth} />
          {/* Comunicado institucional: una sola vez por persona, al iniciar
              sesión y antes del Home. Solo en PWA/celular. */}
          <ComunicadoModal isAuth={isAuth} cedula={cedulaUsuario} />
          <PerfilModalSlot
            isOpen={perfilModalOpen}
            forzado={perfilBloqueado}
            onSaltar={() => setPerfilModalOpen(false)}
            onGuardado={() => {
              // Avisar al hook que el perfil fue guardado para refrescar el estado.
              window.dispatchEvent(new Event(PERFIL_REFETCH_EVENT));
              setPerfilModalOpen(false);
            }}
          />
        </IonReactRouter>
      </MuiPickersUtilsProvider>
    </IonApp>
  );
};

export default App;
